<template>
  <layout title="Dashboard">
    <main class="relative z-0 flex-1 overflow-y-auto focus:outline-none" tabindex="0">
      <!-- Page title & actions -->
      <div class="px-4 py-4 border-b border-gray-200 sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8">
        <div class="flex-1 min-w-0">
          <h1 class="text-lg font-medium leading-6 text-gray-900 sm:truncate">
            Dashboard
          </h1>
        </div>
        <div class="flex mt-4 sm:mt-0 sm:ml-4">
        </div>
      </div>

      <div class="hidden mt-8 sm:block">
        <div class="inline-block min-w-full align-middle border-b border-gray-200">
          <table class="min-w-full">
            <thead>
              <tr class="border-t border-gray-200">
                <th
                  class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                  <span class="lg:pl-2">Campagnes</span>
                </th>
                <th
                  class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                  Start op
                </th>
                <th
                  class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                  Eindigt op
                </th>
                <th
                  class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                  Aantal deelnemers
                </th>
                <th
                  class="hidden px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 md:table-cell bg-gray-50">
                  Pogingen per deelnemer
                </th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-100">
              <tr class="hover:bg-gray-100" v-for="campaign in campaigns.data" :key="campaign.id">
                <td class="px-6 py-3 text-sm font-medium leading-5 text-gray-900 whitespace-nowrap max-w-0">
                  <div class="flex items-center space-x-3 lg:pl-2">
                    <div class="flex-shrink-0 w-2.5 h-2.5 rounded-full bg-red-600" :class="{'bg-green-600' : campaign.hasEnded }" ></div>
                    <a :href="'/campaign/' + campaign.id + ''" class="truncate hover:text-gray-600">
                      <span>{{ campaign.name }}</span>
                    </a>
                  </div>
                </td>
                <td class="px-6 py-3 text-sm font-medium leading-5 text-gray-500">
                  {{ campaign.starting_at }}
                </td>
                <td class="px-6 py-3 text-sm font-medium leading-5 text-gray-500">
                  {{ campaign.finished_at }}
                </td>
                <td class="px-6 py-3 text-sm font-medium leading-5 text-gray-500">
                  {{ campaign.attendees_amount }}
                </td>
                <td class="px-6 py-3 text-sm font-medium leading-5 text-gray-500">
                  {{ campaign.attempts_per_user }}
                </td>

              </tr>

              <!-- More project rows... -->
            </tbody>
          </table>
        </div>
      </div>
      <Pagination :links="campaigns.links" :meta="campaigns.meta" class="" />
    </main>
  </layout>
</template>

<script>
import Layout from '@/Shared/Layout'
import Pagination from '../../Shared/Pagination.vue';

export default {
  props: {
    campaigns: Object
  },
  components: {
    Layout,
    Pagination,
  },
  data: () => ({
    campaignOptionDropdownId: null,
  }),
  methods: {
    campaignOptionDropdown(id) {
      return this.campaignOptionDropdownId === id;
    },
    clickCampaignOptionDropdown(id) {
      if (this.campaignOptionDropdownId === id) {
        this.campaignOptionDropdownId = null;
      } else {
        this.campaignOptionDropdownId = id;
      }
    }
  }
}

</script>
